var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7887 28.0156C8.55374 28.0156 5.53817 27.0747 3 25.4512C5.15499 25.5907 8.95807 25.2567 11.3236 23.0004C7.76508 22.8371 6.16026 20.1079 5.95094 18.9416C6.25329 19.0582 7.6953 19.1982 8.50934 18.8716C4.4159 17.8452 3.78793 14.2529 3.92748 13.1566C4.695 13.6931 5.99745 13.8797 6.50913 13.8331C2.69479 11.1039 4.06703 6.99838 4.74151 6.11197C7.47882 9.90429 11.5812 12.0342 16.6564 12.1527C16.5607 11.733 16.5102 11.296 16.5102 10.8473C16.5102 7.62654 19.1134 5.01563 22.3247 5.01563C24.0025 5.01563 25.5144 5.72838 26.5757 6.86846C27.6969 6.60573 29.3843 5.99069 30.2092 5.45883C29.7934 6.95173 28.4989 8.19712 27.7159 8.6587C27.7224 8.6744 27.7095 8.64293 27.7159 8.6587C28.4037 8.55466 30.2648 8.19699 31 7.69818C30.6364 8.53688 29.264 9.93135 28.1377 10.712C28.3473 19.9537 21.2765 28.0156 11.7887 28.0156Z",
    fill: "#47ACDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1b40be6be7ac3c0c0509ca4b16838cce.svg";
export { ForwardRef as ReactComponent };